import { productsApiAdapter, productsFilterAdapter } from './products';
import { variationsApiAdapter } from './variations';
import { productOrdersApiAdapter } from './orders';
import { marketCountriesApiAdapter } from './marketCountries';

const productsDomainApiAdapter = {
  ...productsApiAdapter,
  ...variationsApiAdapter,
  ...productOrdersApiAdapter,
  ...marketCountriesApiAdapter,
};

export { productsDomainApiAdapter as productsApiAdapter, productsFilterAdapter };
